module.exports = __webpack_public_path__ + "static/media/avatar-counsellor.a97a8a73.jpeg";